import { render, staticRenderFns } from "./hour-statistics-details.vue?vue&type=template&id=64e0eb62&scoped=true"
import script from "./hour-statistics-details.vue?vue&type=script&lang=js"
export * from "./hour-statistics-details.vue?vue&type=script&lang=js"
import style0 from "./hour-statistics-details.vue?vue&type=style&index=0&id=64e0eb62&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e0eb62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64e0eb62')) {
      api.createRecord('64e0eb62', component.options)
    } else {
      api.reload('64e0eb62', component.options)
    }
    module.hot.accept("./hour-statistics-details.vue?vue&type=template&id=64e0eb62&scoped=true", function () {
      api.rerender('64e0eb62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/hour-statistics-details.vue"
export default component.exports